import { render, staticRenderFns } from "./TrustCenter.vue?vue&type=template&id=6e485ee4&"
import script from "./TrustCenter.vue?vue&type=script&lang=js&"
export * from "./TrustCenter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports